/**
 * Directive: resourceType
 */
angular.module('acme.common.directive.resourceType', [
  'acme.common.service.helpers',
  'acme.common.directive.resourceTypeView',
  'acme.common.directive.resourceTypeEdit'
])
.directive('resourceType', [function() {

  return {

    restrict: 'A',
    replace: true,
    templateUrl: 'common/directives/resourceType/resourceType.tpl.html',
    scope: {
      model: '=',
      saved: '=',
      state: '@',
      sref: '@',
      type: '@',
      index: '@',
      disableActions: '@disableactions',
      showHeader: '=showheader'
    },

    link: function($scope, $element, $attrs) {
      // Modified after controller runs
      $scope.$watch('model', $scope.resourceType.onModelUpdate);
      $scope.$watch('saved', $scope.resourceType.onSavedModelUpdate);

    },

    controller: ['$scope', 'HelpersService', function($scope, HelpersService) {

      $scope.resourceType = {

        model: {
          type: '',
          resourceCategory: '',
          resourceTemplateId: '',
          quantity: 1,
          fields: [],
          srcFields: []
        },

        init: function() {

          $scope.$on('resourceType::stateChange', this.onResourceTypeStateChange);
          $scope.$on('resourceType::done', this.onResourceTypeDone);
          $scope.$on('resourceType::update', this.onResourceTypeUpdate);

          $scope.$on('resourceTypeEdit::selectFieldValue', this.onResourceTypeEditSelectFieldValue);
          $scope.$on('resourceTypeEdit::save', this.onResourceTypeEditSave);
          $scope.$on('resourceTypeEdit::remove', this.onResourceTypeRemove);
          $scope.$on('resourceTypeView::remove', this.onResourceTypeRemove);
        },

        showView: function(name) {
          return ($scope.state === name);
        },

        deleteResource : function() {
        },

        isInState: function(state) {
          return ($scope.state === state);
        },

        getFieldValue: function(field) {
          var r = [],
            list = HelpersService.getFieldValue(field);

          if (list instanceof Array) {
            r = list;
          }else if (list) {
            r = [list];
          }else if (field.hasOwnProperty('value') && field.hasOwnProperty('name')) {
            r = [field.value];
          }

          console.log('resourceType::getFieldValue', r);

          return r;
        },

        onSavedModelUpdate: function(model) {
          var i, ii,
            fields = [];

          console.log('resourceType::onSavedModelUpdate', model);
          if (model) {
            if (model.fields instanceof Array) {
              for (i = 0, ii = model.fields.length; i < ii; i++) {
                fields.push({
                  name: model.fields[i].name,
                  value: model.fields[i].value || $scope.resourceType.getFieldValue(model.fields[i])[0]
                });
              }
            }

            $scope.resourceType.model.quantity = model.quantity;
            $scope.resourceType.model.fields = fields;

          }

        },

        onModelUpdate: function(model) {
          console.log('resourceType::onModelUpdate', model);

          if (model) {

            $scope.resourceType.model.type = model.type || model.name;
            $scope.resourceType.model.resourceCategory = model.resourceCategory;
            $scope.resourceType.model.resourceTemplateId = model.resourceTemplateId || model.id;
            $scope.resourceType.model.quantity = model.quantity;
            if (!$scope.saved) {
              $scope.resourceType.model.fields = model.fields;
            }
            $scope.resourceType.model.srcFields = model.fields;

          }

        },

        onResourceTypeStateChange: function(e, data) {
          $scope.state = data.state;
        },

        onResourceTypeUpdate: function(e, data) {
          //angular.copy($scope.resourceType.model, $scope.model);

          $scope.saved.type = $scope.resourceType.model.type;
          $scope.saved.resourceCategory = $scope.resourceType.model.resourceCategory;
          $scope.saved.resourceTemplateId = $scope.resourceType.model.resourceTemplateId;
          $scope.saved.quantity = $scope.resourceType.model.quantity;
          $scope.saved.fields = $scope.resourceType.model.fields;

          $scope.$emit('resourceType::update::complete', {
            resource: {
              type: $scope.resourceType.model.type,
              resourceCategory: $scope.resourceType.model.resourceCategory,
              resourceTemplateId: $scope.resourceType.model.resourceTemplateId,
              quantity: $scope.resourceType.model.quantity,
              fields: $scope.resourceType.model.fields
            }
          });

          console.log('resourceType::onResourceTypeUpdate', $scope.saved);

        },

        onResourceTypeDone: function(e, data) {
          //angular.copy($scope.resourceType.model, $scope.model);

          $scope.saved.type = $scope.resourceType.model.type;
          $scope.saved.resourceCategory = $scope.resourceType.model.resourceCategory;
          $scope.saved.resourceTemplateId = $scope.resourceType.model.resourceTemplateId;
          $scope.saved.quantity = $scope.resourceType.model.quantity;
          $scope.saved.fields = $scope.resourceType.model.fields;

          $scope.$emit('resourceType::done::complete', {
            resource: {
              type: $scope.resourceType.model.type,
              resourceCategory: $scope.resourceType.model.resourceCategory,
              resourceTemplateId: $scope.resourceType.model.resourceTemplateId,
              quantity: $scope.resourceType.model.quantity,
              fields: $scope.resourceType.model.fields
            }
          });
          console.log('resourceType::onResourceTypeDone', $scope.saved);

        },

        onResourceTypeRemove: function(e, data) {
          $scope.$emit('resourceType::remove', {
            resource: $scope.resourceType.model,
            index: $scope.index
          });
        },

        onResourceTypeEditSave: function(e, data) {
          console.log('resourceTypeView::onResourceTypeEditSave', data);
          angular.copy(data.fields, $scope.resourceType.model.fields);
          $scope.$emit('resourceType::save', {
            resource: $scope.resourceType.model,
            index: $scope.index
          });
        },

        onResourceTypeEditSelectFieldValue: function(e, data) {
          console.log('resourceTypeView::onResourceTypeEditSelectFieldValue', data);
          angular.copy(data.fields, $scope.resourceType.model.fields);
          $scope.$emit('resourceType::edit', {
            resource: $scope.resourceType.model
          });
        }

      };

      $scope.resourceType.init();

    }]

  };

}]);